import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const classificationgroups = 
{
    namespaced: true,
    state: {
        Customers: [], 
        Customer: {}
    },
    mutations: {
        SET_CUSTOMERS(state, data)
        {
            state.Customers = data
        },
        SET_CUSTOMER(state, data)
        {
            state.Customer = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'Customers', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_CUSTOMERS', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deleteCustomer ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updateCustomer({ commit }, {id, data}){
            return axios
            .post(baseUrl+'Customers/updateCustomer/' + id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getCustomer ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewCustomer ({ commit }, data) {
            return axios
            .post(baseUrl+'Customers/addCustomer', data, { withCredentials: true }, {
                headers: {
                    'Content-Type': 'application/json'
                    // You can add more headers if needed
                }
            })
            
            .then(res => {
                console.log("Customer Added:" , res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default classificationgroups